/* SiteGridViewRenderer.js */

"use strict";
/* global $, kendo */
const EntityGrid = require("@gluenetworks/entity_grid_gl").Grid;
const Registrations = require("../../../../../RegistrationNamespaces");
const DistinctValuesFeed = require("../../../../lib/DistinctValuesFeed");
require("@progress/kendo-ui/js/kendo.treeview");
const _ = require("lodash");
const TreeUtils = require("../../treeUtilities");

class SiteGridViewRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("site-grid-view-gl");
        this._treeComponent = undefined;
        this._treeContainer = document.createElement("tree-container");
        this._gridContainer = document.createElement("grid-container-wrapper");
        this._resizer = document.createElement("div");
        this._resizer.className = "resizer";
        this._resizer.id = "resizer";
        this._documentWidth = document.body.clientWidth;
        this._resizer.style.width = (this._documentWidth * 0.3) / 100 + "px";
        this._treeContainer.style.width = 200 + "px";
        this._panelEl = document.createElement("span");
        this._panelEl.classList.add("active", "treeview-toggle");
        this._panelEl.setAttribute("title", "Sites");
        this._panelEl.innerHTML = `<actionable-icon-gl data-icon="topology.solution" data-dark-theme="true" class="dark"></actionable-icon-gl>`;
        this.rootElement.appendChild(this._treeContainer);
        this.rootElement.appendChild(this._resizer);
        this.rootElement.appendChild(this._gridContainer);
        const geHeaderL =
            this._model._gameEditor.renderer._rootElem.querySelector(".ge-header-left");
        const existingTreeToggle = geHeaderL.querySelector(".treeview-toggle");
        if (existingTreeToggle) {
            existingTreeToggle.remove();
        }
        geHeaderL.appendChild(this._panelEl);
        this._deleteNode = this._deleteNode.bind(this);
        this._expandTree = _.debounce(this._expandTree.bind(this), 100);
        this._setExpandedSitesData = _.debounce(this._setExpandedSitesData.bind(this), 200);
        this._moCallback = this._moCallback.bind(this);
        this._logger = this._model.logger;
        this._userDataStorage = this._model._storageFactory.getRemoteStorageInstance(
            "view",
            "site_details"
        );
        this._userDeviceDataStorage = this._model._storageFactory.getRemoteStorageInstance(
            "view",
            "device_details"
        );
        this._defaultViewActive = false;
        // Deferred tree regeneration: skip expensive rebuilds when tree is hidden
        this._isTreeVisible = true;
        this._hasPendingTreeRegeneration = false;
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._panelEl.removeEventListener("click", this._toggleTree);
        this._panelEl.addEventListener("click", (this._toggleTree = this._toggleTree.bind(this)));

        this._resizer.addEventListener(
            "mousedown",
            (this._onResizerMousedown = this._onResizerMousedown.bind(this))
        );
        window.addEventListener(
            "resize",
            (this._onWindowResize = () => {
                this._documentWidth = document.body.clientWidth;
                this._treeContainer.style.width =
                    (this._userDeviceDataStorage.getData("treeContainerWidth", true) || 200) + "px";
            })
        );

        this._model.on(
            "FeedInitialized",
            (this._onFeedInitialized = this._onFeedInitialized.bind(this))
        );

        // this._model.gameEditor.on('ColumnSettingsChange', this._onColumnSettingsChanged = this._onColumnSettingsChanged.bind(this));
        this._model.on(
            "GridColumnUpdated",
            (this._onGridColumnUpdated = this._onGridColumnUpdated.bind(this))
        );
        this._model.pagingFeed.on(
            "RefreshView",
            (this._onFeedRefreshView = this._onFeedRefreshView.bind(this))
        );
        this._model._gameEditor.on(
            "OrganizationChanged",
            (this._onOrgChanged = this._onOrgChanged.bind(this))
        );
        this._model._gameEditor._LMRBLayout.on(
            "SelectRowsOnSiteGrid",
            (this._onSelectRowsOnSiteGrid = this._onSelectRowsOnSiteGrid.bind(this))
        );
        this._model.on(
            "RegenerateTreeData",
            (this._onRegenerateTreeData = this._onRegenerateTreeData.bind(this))
        );
        $("tree-container").on("click", ".k-i-delete", this._deleteNode);
        this._registerGridListeners();
    }

    _registerGridListeners() {
        this._siteEntityGrid.on(
            "UserSelectedRows",
            (this._onGridUserSelectedRows = this._onGridUserSelectedRows.bind(this))
        );
        this._siteEntityGrid.on(
            "UserRowDoubleClicked",
            (this._onUserDblClickedRow = this._onUserDblClickedRow.bind(this))
        );
        this._siteEntityGrid.on("UserSorted", (this._onUserSorted = this._onUserSorted.bind(this)));
        this._siteEntityGrid.on(
            "GridBusyStart",
            (this._onGridBusyStart = this._onGridBusyStart.bind(this))
        );
        // BasicSearchFilterChangeData  AdvancedSearchFilterChangeData
        // this._siteEntityGrid.on("BasicSearchFilterChangeData", (this._onFilterChange = this._onFilterChange.bind(this)));
        // this._siteEntityGrid.on("AdvancedSearchFilterChangeData", (this._onFilterChange = this._onFilterChange.bind(this)));
    }

    _unregisterListeners() {
        if (this._resizer) {
            this._resizer.removeEventListener("mousedown", this._onResizerMousedown);
        }
        window.removeEventListener("resize", this._onWindowResize);
        if (this._panelEl) {
            this._panelEl.removeEventListener("click", this._toggleTree);
        }

        if (this._model) {
            this._model.removeListener("FeedInitialized", this._onFeedInitialized);
            this._model.removeListener("GridColumnUpdated", this._onGridColumnUpdated);
            if (this._model.pagingFeed) {
                this._model.pagingFeed.removeListener("RefreshView", this._onFeedRefreshView);
            }
            if (this._model._gameEditor) {
                if (this._model._gameEditor._LMRBLayout) {
                    this._model._gameEditor._LMRBLayout.removeListener(
                        "SelectRowsOnSiteGrid",
                        this._onSelectRowsOnSiteGrid
                    );
                }
                this._model._gameEditor.removeListener("OrganizationChanged", this._onOrgChanged);
            }
        }
        $("tree-container").off("click", ".k-i-delete", this._deleteNode);
        if (this._siteEntityGrid) {
            this._unregisterGridListeners();
        }
    }

    _unregisterGridListeners() {
        this._siteEntityGrid.removeAllListeners("UserSelectedRows");
        this._siteEntityGrid.removeAllListeners("UserRowDoubleClicked");
        this._siteEntityGrid.removeListener("UserSorted", this._onUserSorted);
        this._siteEntityGrid.removeListener("GridBusyStart", this._onGridBusyStart);
        // this._siteEntityGrid.removeListener("BasicSearchFilterChangeData", this._onFilterChange);
        // this._siteEntityGrid.removeListener("AdvancedSearchFilterChangeData", this._onFilterChange);
    }

    _renderAvailableActions() {
        this._model.gameEditor.enableAction(Registrations.SITE_EXPLORER_ACTION_CREATE_SITE);
        // let numSelected = this.selectedRows.length || 0;
        // let rowCount = this.model.pagingFeed.totalEntities || 0;
        // // this._model.gameEditor.hideViewAction(Registrations.DEVICE_EXPLORER_VIEW_GRID);
        // if (numSelected > 0) {
        //     this._model.gameEditor.enableAllActions();
        // } else {
        //     this._model.gameEditor.disableAllActions();
        //     this._model.gameEditor.enableAction(Registrations.DEVICE_EXPLORER_ACTION_CREATE_OS_PLAN);
        //     this._model.gameEditor.enableAction(Registrations.SITE_EXPLORER_ACTION_CREATE);
        //     this._model.gameEditor.enableAction(Registrations.DEVICE_EXPLORER_ACTION_IMPORT);
        //     this._model.gameEditor.enableAction(Registrations.DEVICE_EXPLORER_ACTION_EXPORT);
        //     this._model.gameEditor.enableAction(Registrations.DEVICE_EXPLORER_ACTION_ADHOC_QUERY);
        // }

        // if (numSelected > 1) {
        //     this._model.gameEditor.disableAction(Registrations.DEVICE_EXPLORER_ACTION_CLONE);
        // }

        // if (rowCount > 0) {
        //     this._model.gameEditor.enableAction(Registrations.DEVICE_EXPLORER_ACTION_REPORT);
        // } else {
        //     this._model.gameEditor.disableAction(Registrations.DEVICE_EXPLORER_ACTION_REPORT);
        // }

        // if (
        //     this._model._solutionName === "device_manager" &&
        //     (this.model.isCiscoSupportEnabled === true || this.model.isNistSupportEnabled) /* && !this._model.gameEditor._cabinetCmpnt._registeredActions.find((actionItem) => actionItem.fullyQualifiedName === Registrations.DEVICE_EXPLORER_ACTION_UPDATE_CISCO)*/
        // ) {
        //     /*this.model.gameEditor.addBarActions([
        //         {fullyQualifiedName: Registrations.DEVICE_EXPLORER_ACTION_UPDATE_CISCO, shown: true, icon: "devicemanager.api_update", title: "Update Support Data", order: 2}
        //     ]);*/
        // } else {
        //     this.model.gameEditor.hideBarAction(Registrations.DEVICE_EXPLORER_ACTION_UPDATE_CISCO);
        // }
    }

    _expandTree() {
        // Calling querySelector to then pass the DOM element to $ is a workaround as jQuery sometimes doesn't find tree-container on first load
        // console.log(this);
        const treeContainerElement =
            this._model._gameEditor.renderer._rootElem.querySelector("tree-container");
        const tv = $(treeContainerElement).data("kendoTreeView");
        const userdata = this._userDeviceDataStorage.getData("site_tree_collapsed_data", true);
        let itemsToExpand;
        if (!userdata || _.isEmpty(userdata) || !userdata[this.model.activeOrgId]) {
            itemsToExpand = undefined;
        } else {
            itemsToExpand = Object.keys(userdata[this.model.activeOrgId]);
        }
        // console.log('tv', tv);
        TreeUtils.expandItemsFromCollapsed(itemsToExpand, tv.dataItems(), tv);
    }

    _moCallback(mutationList /*, observer*/) {
        mutationList.forEach((mutation) => {
            if (mutation.type === "attributes" && mutation.attributeName === "aria-busy") {
                this._expandTree();
            }
        });
    }

    _setExpandedSitesData(tv) {
        if (!tv) {
            return;
        }
        const collapsedSites = TreeUtils.getCollapsedSites(tv.dataItems());
        const userdata = this._userDeviceDataStorage.getData("site_tree_collapsed_data", true);
        let collapsedSiteData;
        if (!userdata || _.isEmpty(userdata)) {
            collapsedSiteData = {};
        } else {
            collapsedSiteData = userdata;
        }
        collapsedSiteData[this.model.activeOrgId] = collapsedSites;
        this._userDeviceDataStorage.setData(collapsedSiteData, "site_tree_collapsed_data");
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();
        if (this._moObserver) {
            this._moObserver.disconnect();
        }
        let promArr = [
            _.isUndefined(this._siteEntityGrid)
                ? Promise.resolve()
                : this._siteEntityGrid.shutdown(),
        ];

        return Promise.all(promArr).then(
            () => {
                this._siteEntityGrid = undefined;
                this._defaultViewActive = undefined;
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
            },
            (err) => {
                this.model._logger.warn(err, "SiteGridViewRenderer.shutdown() error");
            }
        );
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        const treeSelectedSite = this._userDeviceDataStorage.getData("site_tree_selected");
        return this._model
            .whenModelIsReady(treeSelectedSite)
            .then(() => {
                const toggleData = this._userDeviceDataStorage.getData(
                    "site_tree_toggle_data",
                    true
                );
                if (toggleData) {
                    const toggleState = toggleData[this.model.activeOrgId];
                    if (!toggleState && toggleState !== undefined) {
                        this._isTreeVisible = false;
                        this._treeContainer.classList.add("hidden");
                        this._resizer.classList.add("hidden");
                    }
                }
                // TREE
                const treeContainerWidth =
                    this._userDeviceDataStorage.getData("treeContainerWidth", true) || 200;
                this._treeContainer.style.width = treeContainerWidth + "px";
                let treeDat = this._model.treeData;
                this._treeRootName = _.get(
                    this._model,
                    "_userSession.activeOrganization.name",
                    "Root"
                );
                // treeDat._pristineProperties = {
                //     name: this._treeRootName,
                //     path: "",
                //     isRoot: true,
                // };
                // console.log(treeDat);
                const kendoTemplate = kendo.template(
                    `
                    #if(item._pristineProperties) {#
                    #if(item._pristineProperties.isRoot) {#<span class='g-icon-globe'>#} else {#<span class='g-icon-#=item.icon#' data-path='#= item._pristineProperties.path#'>#}#
                    </span> #= item._pristineProperties.name #  #if(!item._pristineProperties.isRoot) {#<a class='k-icon k-i-delete' data-id='#= item._id#' data-name='#= item._pristineProperties.name#' ></a>#}#
                    #}#
                    `
                );

                // Calling querySelector to then pass the DOM element to $ is a workaround as jQuery sometimes doesn't find tree-container on first load
                const treeContainerElement =
                    this._model._gameEditor.renderer._rootElem.querySelector("tree-container");
                const targetNode = treeContainerElement;
                const observerOptions = {
                    attributes: true,
                    subtree: false,
                };

                this._moObserver = new MutationObserver(this._moCallback);
                this._moObserver.observe(targetNode, observerOptions);

                const orgName = _.get(this._model, "_userSession.activeOrganization.name");
                this._treeComponent = $(treeContainerElement).kendoTreeView({
                    template: kendoTemplate,
                    dataSource: treeDat,
                    dragAndDrop: true,
                    checkboxes: false,
                    loadOnDemand: false,
                    dataTextField: "_pristineProperties.name",
                    dataSpriteCssClassField: "sprite",
                    select: (e) => {
                        let tv = $("tree-container").data("kendoTreeView");
                        let node = tv.dataItem(e.node);
                        this._model._selectedNode = node;
                        this._updateFilter(node);
                    },
                    expand: () => {
                        const tv = $("tree-container").data("kendoTreeView");
                        // console.log("expand");
                        // console.log(e);
                        this._setExpandedSitesData(tv);
                    },
                    collapse: () => {
                        const tv = $("tree-container").data("kendoTreeView");
                        // console.log("collapse");
                        // console.log(e);
                        this._setExpandedSitesData(tv);
                    },
                    drag: function (e) {
                        // check if siblings have same name
                        let tv = $("tree-container").data("kendoTreeView");
                        const sourceNode = tv.dataItem(e.sourceNode);
                        if (!sourceNode || !sourceNode._pristineProperties) {
                            e.setStatusClass("k-denied");
                            return;
                        }
                        const sourceName = sourceNode._pristineProperties["name"];
                        if (sourceNode._pristineProperties["isRoot"] || sourceName === orgName) {
                            e.setStatusClass("k-denied");
                            return;
                        }
                        let dtItem = tv.dataItem(e.dropTarget);
                        // let dtChildren = tv.dataItem(e.dropTarget).children;
                        if (!dtItem) {
                            e.setStatusClass("k-denied");
                            return;
                        }
                        let dropTargetChildren = dtItem.hasChildren ? dtItem.children.data() : [];
                        let isDuplicate = false;
                        for (let i = 0; i < dropTargetChildren.length; i++) {
                            if (dropTargetChildren[i]._pristineProperties["name"] === sourceName) {
                                isDuplicate = true;
                                break;
                            }
                        }
                        if (isDuplicate) {
                            e.setStatusClass("k-denied");
                        }
                        if (e.statusClass === "denied") {
                            // The TreeView already denies this operation.
                            return;
                        } else {
                            // Whether the action is related to a root node.
                            let targetsRoot =
                                $(e.dropTarget).parentsUntil(".k-treeview", ".k-item").length === 1;

                            // If targeting a root node and the operation is not add.
                            // This means that the operation is to insert before or after the root
                            //  which will create another root.
                            if (
                                targetsRoot &&
                                e.statusClass !== "add" &&
                                e.statusClass !== "i-plus"
                            ) {
                                e.setStatusClass("k-denied");
                            }
                        }
                    },
                    drop: (e) => {
                        let tv = $("tree-container").data("kendoTreeView");
                        const sourceNode = tv.dataItem(e.sourceNode);
                        if (!sourceNode || !sourceNode._pristineProperties) {
                            e.setValid(false);
                            return;
                        }
                        const sourceName = sourceNode._pristineProperties["name"];
                        if (sourceNode._pristineProperties["isRoot"] || sourceName === orgName) {
                            e.setValid(false);
                            return;
                        }
                        let dtItem = tv.dataItem(e.dropTarget);
                        // let dtChildren = tv.dataItem(e.dropTarget).children;
                        if (!dtItem) {
                            e.setValid(false);
                            return;
                        }
                        let dropTargetChildren = dtItem.hasChildren ? dtItem.children.data() : [];
                        let isDuplicate = false;
                        for (let i = 0; i < dropTargetChildren.length; i++) {
                            if (dropTargetChildren[i]._pristineProperties["name"] === sourceName) {
                                isDuplicate = true;
                                break;
                            }
                        }
                        e.setValid(!isDuplicate);
                        if (!isDuplicate) {
                            const destNode = tv.dataItem(e.destinationNode);
                            const targetType = e.dropPosition;
                            const destPath =
                                targetType === "over"
                                    ? destNode._pristineProperties.path
                                    : destNode.parentNode()._pristineProperties.path;
                            if (destPath.search(sourceName) >= 0) {
                                e.setValid(false);
                            } else {
                                const destId =
                                    targetType === "over"
                                        ? destNode._id
                                        : destNode.parentNode()._id;
                                const currPath = destPath + "/" + sourceName;
                                this._model
                                    .updatePathForSite(sourceNode._id, destId)
                                    .then(() => {
                                        sourceNode._pristineProperties.path = currPath;
                                        this._updateFilter(tv.dataItem(tv._getSelectedNode()[0]));
                                    })
                                    .catch((err) => {
                                        console.log(err);
                                    });
                            }
                        }
                    },
                });

                this._siteEntityGrid = new EntityGrid({
                    gridKey: this.model._gridKey,
                    userGridData: this._model._userGridData,
                    logger: this._logger,
                    singleSelect: false,
                    columns: this._model.columnConfig,
                    pagingFeed: this._model.pagingFeed,
                    selectedRows: _.get(this._model.getSelectedSiteIds(), "selectedRows", []),
                    showHeader: true,
                    showLinesNumber: this._model._gameEditor.renderer._rootElem.querySelector(
                        "game-editor-view-actions-gl left-container"
                    ),
                    columnSettingsWidgetContainer:
                        this._model._gameEditor.renderer._rootElem.querySelector(".ge-header-left"),
                    // panelToggleButtonContainer: this._model._gameEditor.renderer._rootElem.querySelector(".ge-header-left"),
                    groupingContainer:
                        this._model._gameEditor.renderer._rootElem.querySelector(".ge-header-left"),
                    filterComponent:
                        this._model._gameEditor.renderer._rootElem.querySelector(".ge-header-left"),
                    advancedFilterComponent:
                        this._model._gameEditor.renderer._rootElem.querySelector(".ge-header-left"),
                    modalUserFeedback: this._model._modalUserFeedback,
                    groupingValuesFeed: new DistinctValuesFeed({
                        startFeed: (fieldName, query, replacementValue) => {
                            if (replacementValue) {
                                return this.model._siteEntityDef.startSiteDistinctValuesFeed(
                                    this.model.activeOrgId,
                                    fieldName,
                                    query,
                                    replacementValue
                                );
                            } else {
                                return this.model._siteEntityDef.startSiteDistinctValuesFeed(
                                    this.model.activeOrgId,
                                    fieldName,
                                    query
                                );
                            }
                        },
                        replacementValue: "Blank",
                    }),
                    externalFilter: this._model._filterForTree,
                });

                if (!this._gridContainer.hasChildNodes()) {
                    this._gridContainer.appendChild(this._siteEntityGrid.renderer.rootElement);
                }

                this._renderAvailableActions();
                this._onFeedRefreshView();
                this._registerListeners();
            })
            .then(() => {
                const openedTabs = this.model.explorerState.openedTabs;
                let openedTabsIds = Object.keys(openedTabs);

                if (this._model._gameEditor._filterFromUrl) {
                    this._siteEntityGrid._advancedFilter._advancedFilter._renderer._applyQuery();
                }

                if (
                    this._model._gameEditor._openEditorFromUrl &&
                    (this._model._gameEditor._openEditorFromUrl.open ||
                        !_.isUndefined(this._model._gameEditor._openEditorFromUrl.selectedIds))
                ) {
                    openedTabsIds = this._model._gameEditor._openEditorFromUrl.selectedIds;
                }

                const activeTabId = this.model.explorerState.activeTab;
                let activeTab = openedTabs[activeTabId];

                if (
                    openedTabs &&
                    openedTabsIds.length > 0 &&
                    this.model.gameEditor._editorLayout.launchedEditors.length === 0
                ) {
                    delete openedTabsIds[activeTabId];

                    openedTabsIds.forEach((tabId) => {
                        if (!this._model._gameEditor._openEditorFromUrl.open) {
                            const openedTab = openedTabs[tabId],
                                ids = openedTab.deviceIds;
                            if (typeof openedTab === "object" && tabId !== activeTabId) {
                                this.model.openDeviceInstanceEditor(ids, openedTab.fqn);
                            }
                        } else {
                            this.model.openDeviceInstanceEditor(tabId);
                            activeTab = undefined;
                        }
                    });

                    //open active tab the lastest
                    if (typeof activeTab === "object") {
                        this.model.openDeviceInstanceEditor(activeTab.deviceIds, activeTab.fqn);
                    }
                }

                //image server status : ONLY ON OSM
                if (this._model._solutionName === "os_manager") {
                    this._model._statusBar.render();
                    this.rootElement.parentElement.parentElement
                        .querySelector("game-editor-view-actions-gl left-container")
                        .appendChild(this._model._statusBar.rootElement);
                }
            })
            .catch((error) => {
                this._logger.warn(
                    {error},
                    "SiteGridViewRenderer.render  --  model is not ready -- error"
                );
            });
    }

    _updateFilter(node, panelHidden = false) {
        if (node === "ontoggle") {
            if (panelHidden) {
                this._siteEntityGrid.clearExternalFilter();
            } else {
                if (!_.isEmpty(this._model._filterForTree)) {
                    this._siteEntityGrid.setExternalFilter(this._model._filterForTree);
                } else {
                    this._siteEntityGrid.clearExternalFilter();
                }
            }
        } else {
            const path = node?._pristineProperties?.path;
            if (path) {
                if (path === "/") {
                    this._model._filterForTree = {};
                } else {
                    const pathVals = TreeUtils.getAllChildrenPaths(node);
                    if (pathVals.length < 50) {
                        this._model._filterForTree = {path: {$in: pathVals}};
                    } else {
                        this._model._filterForTree = {path: {$regex: "^" + path + "(/|$)"}};
                    }
                }
                this._userDeviceDataStorage.setData(node._id, "site_tree_selected");
                this._siteEntityGrid.setExternalFilter(this._model._filterForTree);
            } else {
                this._siteEntityGrid.clearExternalFilter();
                this._model._filterForTree = {};
                this._userDeviceDataStorage.setData("", "site_tree_selected");
            }
        }
    }

    get rootElement() {
        return this._rootElem;
    }

    get model() {
        return this._model;
    }

    get selectedRows() {
        return this._siteEntityGrid.getSelectedRows();
    }

    restartGrid() {
        this._unregisterGridListeners();
        return this._siteEntityGrid.shutdown().then(() => {
            this._instantiateGrid();
            this._gridContainer.appendChild(this._siteEntityGrid.renderer.rootElement);
            this._registerGridListeners();
            this._renderAvailableActions();
        });
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    _showDefaultMessageDisplay() {
        let message = {
            message: "Add site",
            icon: "siteexplorer.add_site",
            action: Registrations.SITE_EXPLORER_ACTION_CREATE_SITE,
        };
        return this._model.gameEditor
            .showDefaultMessageView(message, this._gridContainer)
            .then(() => {
                this._defaultViewActive = true;
            })
            .catch((err) => {
                this._logger.warn(
                    {error: err},
                    "SiteListViewerRenderer._showDefaultMessageDisplay error"
                );
            });
    }

    _hideDefaultMessageDisplay() {
        return this._model.gameEditor
            .hideDefaultMessageView()
            .then(() => {
                this._defaultViewActive = false;
            })
            .catch((err) => {
                this._logger.warn(
                    {error: err},
                    "SiteListViewerRenderer._hideDefaultMessageDisplay error"
                );
            });
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onGridBusyStart() {
        if (this._model.pagingFeed.totalEntities > this._model.pagingFeed.pageSize * 2) {
            let gridBusyEnded = false;
            this._siteEntityGrid.once("GridBusyEnd", () => {
                gridBusyEnded = true;
            });
            this._model._modalUserFeedback.displayLoading().then(() => {
                if (gridBusyEnded) {
                    this._model._modalUserFeedback.hideDisplayed();
                } else {
                    this._siteEntityGrid.once("GridBusyEnd", () => {
                        this._model._modalUserFeedback.hideDisplayed();
                    });
                }
            });
        }
    }

    // _onFilterChange() {
    //     if (this._model._selectedNode && !_.isEmpty(this._model._filterForTree)) {
    //         let pagingFilter = this._model._pagingSiteFeed.getFilterData();
    //         if (pagingFilter.$userQuery) {
    //             pagingFilter = pagingFilter.$userQuery;
    //         }

    //         const filter = Array.isArray(pagingFilter) ?
    //             { "$and": pagingFilter.concat([this._model._filterForTree])} :
    //             { "$and": [
    //                 pagingFilter,
    //                 this._model._filterForTree
    //             ]};
    //         this._model._pagingSiteFeed.setFilter(filter);
    //     }
    // }

    _onFeedInitialized() {
        // this._renderGridRows();
        this._renderAvailableActions();
    }

    _onUserSorted(eventData) {
        this._model.onUserSorted(eventData);
    }

    _onUserDblClickedRow(obj) {
        let view = Registrations.SIE_VIEW_DETAILS;
        view =
            this._userDataStorage.getData("SE_active_view", true) || Registrations.SIE_VIEW_DETAILS;
        this._model.openSiteInstanceEditor(obj.selectedRow, view);
    }

    _onGridUserSelectedRows(selectedRowIds) {
        this._model._gameEditor._editorLayout.emit("UserSelectedRows", selectedRowIds || []);
        this._model.updateExplorerState("selectedIds", selectedRowIds || []);
        this._renderAvailableActions();
    }

    _onFeedRefreshView() {
        const totalEntities = this._model.pagingFeed.totalEntities;
        const filterData = this._model.pagingFeed.getFilterData();
        if (totalEntities === 0 && _.isEmpty(_.get(filterData, "$userQuery", filterData))) {
            if (this._defaultViewActive === false) {
                this._showDefaultMessageDisplay();
            }
        } else {
            if (this._defaultViewActive === true) {
                this._hideDefaultMessageDisplay();
            }
        }
    }
    _onGridColumnUpdated() {
        this._model.gameEditor.onGridColumnUpdated();
    }

    _onSelectRowsOnSiteGrid(rowIdsToSelect) {
        this._siteEntityGrid.setSelectedRows(rowIdsToSelect);
    }

    _onOrgChanged() {
        this._userDeviceDataStorage.setData("", "site_tree_selected");
        this._model._filterForTree = {};
    }

    _onResizerMousedown(e) {
        let treeWidth = this._treeContainer.style.width;
        e = e || window.event;
        let start = 0,
            diff = 0;
        if (e.pageX) {
            start = e.pageX;
        } else if (e.clientX) {
            start = e.clientX;
        }

        document.body.onmousemove = (e) => {
            e = e || window.event;
            let end = 0;
            if (e.pageX) {
                end = e.pageX;
            } else if (e.clientX) {
                end = e.clientX;
            }

            diff = end - start;
            let updatedTreeWidth = this._treeContainer.style.width;
            if (parseInt(updatedTreeWidth, 10) > 100 || diff > 0) {
                this._treeContainer.style.width = parseInt(treeWidth, 10) + diff + "px";
            }
        };
        document.body.onmouseup = () => {
            this._userDeviceDataStorage.setData(
                parseInt(this._treeContainer.style.width, 10),
                "treeContainerWidth"
            );
            document.body.onmousemove = document.body.onmouseup = null;
        };
    }

    /**
     * Toggles tree panel visibility with deferred regeneration optimization.
     * When hidden, expensive tree rebuilds are deferred until tree is shown.
     */
    _toggleTree() {
        this._treeContainer.classList.toggle("hidden");
        this._resizer.classList.toggle("hidden");
        this._panelEl.classList.toggle("active");

        const isSitePanelHidden = this._treeContainer.classList.contains("hidden");

        this._model._onSitePanelVisibilityChanged(!isSitePanelHidden);
        if (isSitePanelHidden) {
            this._updateFilter("ontoggle", true);
            this._isTreeVisible = false;
        } else {
            this._updateFilter("ontoggle", false);
            this._isTreeVisible = true;

            if (this._hasPendingTreeRegeneration) {
                this._onRegenerateTreeData();
            }
        }

        let toggleData = this._userDeviceDataStorage.getData("site_tree_toggle_data", true) || {};
        toggleData[this.model.activeOrgId] = !isSitePanelHidden;
        this._userDeviceDataStorage.setData(toggleData, "site_tree_toggle_data");
    }

    /**
     * Regenerates tree data from backend (expensive operation).
     * Deferred when tree is hidden to avoid unnecessary work.
     */
    _onRegenerateTreeData() {
        if (!this._isTreeVisible) {
            this._hasPendingTreeRegeneration = true;
            return;
        }

        this._hasPendingTreeRegeneration = false;

        let tv = $("tree-container").data("kendoTreeView");
        this._model
            .loadAllSites()
            .then(() => {
                let treeDat = this._model.generateTreeData();
                tv.setDataSource(treeDat);
                // console.log("tree update", treeDat);
                const selectedPath = _.get(
                    this._model,
                    "_selectedNode._pristineProperties.path",
                    _.get(this._model, "_selectedNode._pristineProperties.name")
                );
                if (selectedPath) {
                    setTimeout(() => {
                        const elWithPath = this._rootElem.querySelector(
                            'span[data-path="' + selectedPath + '"'
                        );
                        // console.log(elWithPath);
                        if (elWithPath) {
                            tv = $("tree-container").data("kendoTreeView");
                            const nodeEl = $(elWithPath).closest(".k-item");
                            const upNode = tv.dataItem(nodeEl);
                            // console.log(upNode);
                            tv.select(nodeEl);
                            this._model._selectedNode = upNode;
                            this._updateFilter(upNode);
                            return;
                        }
                        this._updateFilter();
                        return;
                    }, 500);
                } else {
                    this._updateFilter();
                }
            })
            .catch((err) => {
                this._logger.warn({error: err}, "Tree regeneration failed");
            });
    }

    _deleteNode(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        const siteId = evt.target.dataset.id;
        const name = evt.target.dataset.name;
        if (!siteId) {
            return;
        }

        this._model.deleteSite(siteId, name);
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    // TODO - Nobody should be using methods on a Renderer directly so make all these methods private

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = SiteGridViewRenderer;
